module.exports = __webpack_public_path__ + "static/img/jcyy-content-2.1a3eac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/chartTexeraJc/jcyy-content-2.png
// module id = sx86
// module chunks = 34